export enum Feature {
  Precision = "precision",
  MultilingualAnalysis = "multilingualAnalysis",
  PreferredLanguage = "preferredLanguage",
  Redaction = "redaction",
  Llm = "llm",
  MultiLingualUi = "multiLingualUi",
}
